import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { t } from '@/lib/i18n';
import { CoreMark } from './core-mark';
import { ThemeToggle } from './theme-toggle';

export function AuthLayout({ children, title, subtitle }: { children: ReactNode; title: string; subtitle: string }) {
  return (
    <div className="auth-shell">
      <aside className="auth-context">
        <div className="auth-brand-row">
          <Link to="/" className="auth-brand" aria-label="aniphys, главная">
            <CoreMark size={32} animated={false} />
            <span>aniphys</span>
          </Link>
          <ThemeToggle />
        </div>
        <div className="auth-statement">
          <strong>{t('app.tagline_1')} {t('app.tagline_2')}</strong>
          <p>{t('app.tagline_sub')}</p>
          <Link className="auth-demo-link" to="/demo">Посмотреть демо <ArrowRight aria-hidden="true" /></Link>
        </div>
        <Link className="auth-domain" to="/legal">Документы и условия использования</Link>
      </aside>
      <main className="auth-main">
        <div className="auth-form-stack">
          <div className="auth-heading">
            <h1>{title}</h1>
            <p>{subtitle}</p>
          </div>
          {children}
        </div>
      </main>
    </div>
  );
}
